import React from 'react';

import { DialogContext, DialogContextValues } from '@webtv/contexts/dialog-context/dialog-context';

export const useDialog = (): DialogContextValues => {
  const values = React.useContext(DialogContext);

  return { ...values };
};

export default useDialog;
